export default {"src":"/_next/static/media/eye.65d5bc29.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};